function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37 101C17.67 101 2 104.806 2 109.5C2 114.194 17.67 118 37 118C56.33 118 72 114.194 72 109.5C72 105.474 60.4748 102.102 45 101.223",
  stroke: "url(#paint0_linear)",
  strokeWidth: 3
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37.31 110.46L5.5 45.5C13.4233 60.6272 21.5 64 36.5 64C53.0145 64 61.9537 52.7776 65.633 45.0035L66.5 43C66.252 43.6328 65.964 44.3042 65.633 45.0035L37.31 110.46Z",
  fill: "#6831DE"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M62.4716 51.3982C70.1917 39.7876 69.7804 24.0425 60.43 12.7503C49.0029 -1.04986 28.5522 -2.97359 14.7521 8.45352C1.92421 19.0755 -0.64179 37.4944 8.23829 51.1211L37.2957 110.46L62.4716 51.3982Z",
  fill: "url(#paint1_linear)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.69 48.0299C26.6153 57.601 40.7989 58.9352 50.3699 51.0099C59.941 43.0847 61.2752 28.9011 53.35 19.33C45.4247 9.7589 31.2411 8.4247 21.67 16.35C12.0989 24.2752 10.7647 38.4588 18.69 48.0299Z",
  fill: "white"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.9734 44.3901C30.929 48.1132 39.8803 50.1612 45 43",
  stroke: "url(#paint2_linear)",
  strokeWidth: 2
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.5 33C29.433 33 31 31.433 31 29.5C31 27.567 29.433 26 27.5 26C25.567 26 24 27.567 24 29.5C24 31.433 25.567 33 27.5 33Z",
  fill: "url(#paint3_linear)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M42.5 30H48.5",
  stroke: "url(#paint4_linear)",
  strokeWidth: 3
});

var _ref9 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 21.5417,
  y1: 101,
  x2: 27.8819,
  y2: 124.915,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#E03BFB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#6831DE"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: -28.5,
  y1: 53,
  x2: 49.5,
  y2: 81.5,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#CF48FF"
}), React.createElement("stop", {
  offset: 0.390624,
  stopColor: "#AE46FF"
}), React.createElement("stop", {
  offset: 0.942708,
  stopColor: "#6831DE"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 32.7266,
  y1: 43,
  x2: 34.7432,
  y2: 49.5795,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#E03BFB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#6831DE"
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 25.9542,
  y1: 26,
  x2: 31.2037,
  y2: 30.8088,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#E03BFB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#6831DE"
})), React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 44.175,
  y1: 30,
  x2: 44.4402,
  y2: 31.4574,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#E03BFB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#6831DE"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 74,
    height: 120,
    viewBox: "0 0 74 120",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo.d338c427.svg";
export { ForwardRef as ReactComponent };